import { i as isFunction_1 } from "./auth-service-tools1218.js";
import { i as isLength_1 } from "./auth-service-tools1219.js";
var isFunction = isFunction_1,
    isLength = isLength_1;

function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike;
export { isArrayLike_1 as i };